import React from 'react';
import styles from './index.css';
// @flow
class DataItem extends React.PureComponent {
    render() {
        const { content: { title, value, grow, gain }, } = this.props;
        let colerStyle = 'black';
        if (gain > 0) {
            colerStyle = 'red';
        }
        else if (gain < 0) {
            colerStyle = 'green';
        }
        const stylesArr = styles;
        return (React.createElement("div", { className: styles.data_item },
            React.createElement("div", null,
                React.createElement("div", { className: styles.title }, title),
                React.createElement("div", { className: `${styles.value} ${stylesArr[colerStyle]}` }, value),
                React.createElement("div", { className: styles.other },
                    React.createElement("span", { className: `${styles.grow} ${stylesArr[colerStyle]}` }, grow > 0 ? `+${grow}` : grow),
                    React.createElement("span", { className: stylesArr[colerStyle] }, gain > 0 ? `+${gain}%` : `${gain}%`)))));
    }
}
export default DataItem;
